import React from 'react';

interface State { error: Error | null }
interface Props { children: React.ReactNode; fallback?: (error: Error) => React.ReactNode }

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };
  static getDerivedStateFromError(error: Error): State { return { error }; }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error.message, error.stack, info.componentStack);
  }
  render() {
    if (this.state.error) {
      if (this.props.fallback) return this.props.fallback(this.state.error);
      return (
        <div className="flex flex-col items-center justify-center flex-1 p-8 gap-3">
          <span className="font-pixel text-neon-red text-xs">ERREUR PIXI</span>
          <pre className="font-mono text-xs text-gray-400 bg-bg-elevated p-4 rounded max-w-lg overflow-auto">
            {this.state.error.message}{'\n'}{this.state.error.stack?.split('\n').slice(1, 4).join('\n')}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}
